export interface ColumnState {
    tables: Record<string, string[]>;
}

export const initialColumnState: ColumnState = { tables: {} };
